const Home = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">Home</h1>
      <p className="text-gray-600">Manage your campaigns and track performance</p>
    </div>
  );
};

export default Home;
